import { observer } from "mobx-react-lite";
import type { ReactNode } from "react";

import { SearchBarDateRangePicker } from "./SearchBarDateRangePicker";
import { TimezoneSelector } from "./TimezoneSelector";
import { useStructuredSearchStore } from "./stores";
import type { CompleteDateRange } from "./stores/structured-search/structured-search-store";

interface TimezoneDateRangeControlsProps {
  minDate?: Date;
  maxDate?: Date;
  onDateRangeChange?: (range: CompleteDateRange) => void;
  trailingControls?: ReactNode;
}

export const TimezoneDateRangeControls = observer(
  ({ minDate, maxDate, onDateRangeChange, trailingControls }: TimezoneDateRangeControlsProps) => {
    const structuredSearchStore = useStructuredSearchStore();

    return (
      <div className="flex w-full min-w-0 flex-wrap items-center gap-2 sm:gap-3 [@media(min-width:1281px)]:w-auto [@media(min-width:1281px)]:justify-end">
        <div className="flex max-w-full shrink-0 items-center">
          <TimezoneSelector triggerClassName="rounded-r-none" />
          <SearchBarDateRangePicker
            dateRange={structuredSearchStore.dateRange}
            minDate={minDate}
            maxDate={maxDate}
            className="-ml-px w-auto"
            triggerClassName="h-10 rounded-l-none focus-visible:relative focus-visible:z-10"
            onDateRangeChange={
              onDateRangeChange ?? (range => structuredSearchStore.setDateRange(range))
            }
          />
        </div>
        {trailingControls}
      </div>
    );
  },
);
